import type { Template } from "@/types";

export const PO_04_H2_V2: Template[] = [
    {
        id: "po-04-h2v2-01",
        name: "PO 01 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 13, y: 262, width: 185, height: 261, rotation: 0, imageRotation: 0 },
            { id: "2", x: 205, y: 262, width: 417, height: 261, rotation: 0, imageRotation: 0 },
            { id: "3", x: 631, y: 262, width: 417, height: 261, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1055, y: 262, width: 185, height: 261, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-02",
        name: "PO 02 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 109, y: 105, width: 408, height: 574, rotation: 0, imageRotation: 0 },
            { id: "2", x: 664, y: 105, width: 549, height: 319, rotation: 0, imageRotation: 0 },
            { id: "3", x: 664, y: 430, width: 178, height: 249, rotation: 0, imageRotation: 0 },
            { id: "4", x: 849, y: 430, width: 364, height: 249, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-03",
        name: "PO 03 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 626, height: 783, rotation: 0, imageRotation: 0 },
            { id: "2", x: 707, y: 147, width: 462, height: 269, rotation: 0, imageRotation: 0 },
            { id: "3", x: 707, y: 423, width: 149, height: 214, rotation: 0, imageRotation: 0 },
            { id: "4", x: 864, y: 423, width: 306, height: 214, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-04",
        name: "PO 04 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 39, y: 199, width: 273, height: 385, rotation: 0, imageRotation: 0 },
            { id: "2", x: 320, y: 199, width: 273, height: 385, rotation: 0, imageRotation: 0 },
            { id: "3", x: 734, y: 132, width: 410, height: 256, rotation: 0, imageRotation: 0 },
            { id: "4", x: 734, y: 395, width: 410, height: 256, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-05",
        name: "PO 05 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 13, y: 262, width: 417, height: 261, rotation: 0, imageRotation: 0 },
            { id: "2", x: 437, y: 262, width: 185, height: 261, rotation: 0, imageRotation: 0 },
            { id: "3", x: 630, y: 262, width: 185, height: 261, rotation: 0, imageRotation: 0 },
            { id: "4", x: 822, y: 262, width: 417, height: 261, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-06",
        name: "PO 06 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 84, y: 166, width: 717, height: 451, rotation: 0, imageRotation: 0 },
            { id: "2", x: 808, y: 166, width: 359, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 808, y: 395, width: 176, height: 223, rotation: 0, imageRotation: 0 },
            { id: "4", x: 991, y: 395, width: 176, height: 223, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-07",
        name: "PO 07 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 78, y: 149, width: 343, height: 486, rotation: 0, imageRotation: 0 },
            { id: "2", x: 428, y: 395, width: 395, height: 239, rotation: 0, imageRotation: 0 },
            { id: "3", x: 428, y: 149, width: 395, height: 239, rotation: 0, imageRotation: 0 },
            { id: "4", x: 831, y: 149, width: 343, height: 486, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-08",
        name: "PO 08 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 78, y: 149, width: 343, height: 486, rotation: 0, imageRotation: 0 },
            { id: "2", x: 428, y: 149, width: 343, height: 486, rotation: 0, imageRotation: 0 },
            { id: "3", x: 778, y: 149, width: 396, height: 239, rotation: 0, imageRotation: 0 },
            { id: "4", x: 778, y: 395, width: 396, height: 239, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-09",
        name: "PO 09 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 262, y: 79, width: 499, height: 309, rotation: 0, imageRotation: 0 },
            { id: "2", x: 768, y: 79, width: 222, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 262, y: 395, width: 222, height: 309, rotation: 0, imageRotation: 0 },
            { id: "4", x: 492, y: 395, width: 498, height: 309, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-10",
        name: "PO 10 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 61, y: 151, width: 372, height: 237, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 395, width: 182, height: 235, rotation: 0, imageRotation: 0 },
            { id: "3", x: 251, y: 395, width: 182, height: 235, rotation: 0, imageRotation: 0 },
            { id: "4", x: 440, y: 151, width: 751, height: 479, rotation: 0, imageRotation: 0 }
        ],
    }
];